'use client';
import { useRef } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import { Button, DoctorCard } from '@/components';
import { SvgArrowLeft, SvgArrowRight } from '@/components/icons';
import { DoctorsByService } from '@/api/doctorsByService/doctorsByService.types';
import s from './DoctorsSlider.module.scss';

const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3.90,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1256,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export const DoctorsSlider = ({ doctors }: { doctors: DoctorsByService[] }) => {
  const sliderRef = useRef<Slider | null>(null);

  return (
    <div className={s.doctors}>
      <div className={s.doctors__head}>
        <h2 className={s.doctors__title}>Врачи</h2>
        <div className={s.doctors__navButtons}>
          <Button
            onClick={() => sliderRef.current?.slickPrev()}
            name=""
            type="button"
            theme="arrow"
            size="small"
            leftIcon={<SvgArrowLeft />}
          />
          <Button
            onClick={() => sliderRef.current?.slickNext()}
            name=""
            type="button"
            theme="arrow"
            size="small"
            leftIcon={<SvgArrowRight />}
          />
        </div>
      </div>
      <Slider {...settings} ref={sliderRef} className={s.doctors__slider}>
        {doctors.map((doctor) => (
          <DoctorCard
            className={s.doctors__card}
            key={doctor.id}
            id={doctor.doctor_id}
            photo={doctor.doctor?.photo}
            experience={doctor.doctor?.experience ?? null}
            lastName={doctor.doctor?.last_name || ''}
            firstName={doctor.doctor?.first_name || ''}
            middleName={doctor.doctor?.middle_name}
            specialisations={doctor.doctor?.specialisations || []}
            category={doctor.doctor?.category?.title}
            minPrice={doctor.price?.price}
          />
        ))}
      </Slider>
      <Link href={'/doctors'} className={s.doctors__showAllButton}>
        Посмотреть всех специалистов
      </Link>
    </div>
  );
};